import { PanelView } from 'modules/movableInk/constants';
import { usePanelContext } from 'modules/movableInk/contexts/Panel';
import { TableCell } from 'ui/tableCell';
import { BlockDetails } from './BlockDetails';
import {
  BlockCellWrapper,
  BlockItemData,
  BlockItemDetail,
  BlockItemPreview,
  BlockItemTitle,
} from './BlocksTable.styles';
import { MovableInkBlock } from '../../../types';
import { Skeleton } from 'ui/skeleton';

type Props = {
  block: MovableInkBlock;
  isLoading: boolean;
  isSelected: boolean;
};

export const DATA_TEST = {
  item: 'mi-block-item',
  itemDetail: 'mi-block-item-detail',
  itemPreview: 'mi-block-item-preview',
  itemTitle: 'mi-block-item-title',
};

export const BlockCell = ({ block, isLoading, isSelected }: Props) => {
  const { setPanelView, updateImageAttribute } = usePanelContext();

  const handleSelectedBlock = (block: MovableInkBlock) => () => {
    updateImageAttribute(block);
    setPanelView(PanelView.Detail);
  };

  return (
    <TableCell>
      <BlockCellWrapper
        onClick={handleSelectedBlock(block)}
        data-has-click={!!handleSelectedBlock(block)}
        data-test={DATA_TEST.item}
        data-selected={isSelected}
      >
        {!isLoading ? (
          <BlockItemPreview $imgSrc={block.imageUrl} data-test={DATA_TEST.itemPreview} />
        ) : (
          <Skeleton height={48} width={56} />
        )}
        <BlockItemData data-loading={isLoading}>
          <BlockItemTitle data-test={DATA_TEST.itemTitle}>
            {!isLoading ? block.name : <Skeleton height={16} width={248} />}
          </BlockItemTitle>
          <BlockItemDetail data-test={DATA_TEST.itemDetail}>
            {!isLoading ? <BlockDetails metadata={block} /> : <Skeleton height={16} width={92} />}
          </BlockItemDetail>
        </BlockItemData>
      </BlockCellWrapper>
    </TableCell>
  );
};
